




































import Vue from 'vue';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import PaymentMethodSelector from '@/components/PaymentMethodSelector.vue';
import SecureAchForm from '@/components/SecureAchForm.vue';
import SecureCard from '@/components/SecureCard.vue';
import CreditCard from '@/models/CreditCard';
import Customer from '@/models/Customer';

export default Vue.extend({
	name: 'PaymentMethods',
	components: {
		PaymentMethodSelector,
		SecureAchForm,
		SecureCard,
	},
	props: {
		achAvailable: { type: Boolean, default: true },
		captcha_token: String,
		customer: {
			type: Object,
			default() {
				return new Customer();
			},
		},
		required: { type: Boolean, default: false },
		type: { type: String, default: 'recurring' },
		validate: Boolean,
		value: String,
	},

	data() {
		return {
			loading: false,
			paymentMethod: '',
		};
	},

	computed: {
		...mapGetters('location', ['location']),

		hasAch(): boolean {
			return this.$store.getters['location/hasAch'];
		},

		isLoggedIn(): boolean {
			return this.$store.getters.isLoggedIn;
		},

		model: {
			get(): string {
				return this.value;
			},
			set(value: string) {
				this.$emit('input', value);
			},
		},

		register(): boolean {
			return this.type === 'register';
		},

		showAch(): boolean {
			return this.achAvailable
				&& !(this.type === 'reservation' || !this.hasAch);
		},
	},

	methods: {
		onTokenizeAch(account: any) {
			this.$emit('ach', account);
		},

		onTokenizeCard(card: CreditCard) {
			this.$emit('credit-card', card);
		},
	},
});
